import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterData'
})
export class DaterangepickerPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (isNaN(value)) {
      return value.name;
    }
    return `${value}天`;
  }

}
